import { SUBSTANCE_COMPONENTS } from './descriptor'
import { PRODUCT_COMPLIANCE_TRANSLATION_GROUP } from '@/libs/i18n/groups'

const complianceInformationV2Descriptor = Object.freeze({
    type: 'compliance-information',
    version: 2,
    defaultTitleKey: 'Page(ReceivedRequest):Component(ComplianceInformation):title',
    fallbackTitle: 'Compliance information',
    defaultNavigationTitleKey: 'Page(ReceivedRequest):Component(ComplianceInformation):navigation-title',
    fallbackNavigationTitle: 'Compliance information',
    defaultDescriptionKey: 'Page(ReceivedRequest):Component(ComplianceInformation):description',
    fallbackDescription: 'Review and provide the compliance information requested for this product.',
    translationGroups: [PRODUCT_COMPLIANCE_TRANSLATION_GROUP],
    capabilities: {
        repeatable: false,
        supportedModes: ['single', 'bulk'],
        supportsReadOnly: false,
        contributesToReply: true,
    },
    dataScopes: {
        reads: [
            'request.details',
            'request.legislations',
            'product.card',
            'product.concern-substances',
            'product.component-concern-substances',
            'substance-lists.configuration',
            'request.reply-documents',
            'product.verification-documents',
        ],
        writes: [
            'product.card',
            'product.concern-substances',
            'product.component-concern-substances',
            'product.verification-documents',
        ],
    },
    effects: {
        publishes: [
            'product.card.changed',
            'product.concern-substances.changed',
            'product.component-concern-substances.changed',
            'product.verification-documents.changed',
        ],
        observes: [
            'product.card.changed',
            'product.concern-substances.changed',
            'product.component-concern-substances.changed',
            'request.reply-document-processing.completed',
        ],
    },
    settingsSchema: {
        type: 'object',
        additionalProperties: false,
        properties: {
            showSummary: { type: 'boolean', default: true },
            enableScipNumber: { type: 'boolean', default: true },
            scipNumberRequired: { type: 'boolean', default: true },
            hideCandidateListCategoriesWhenScipProvided: { type: 'boolean', default: false },
            showRequirementsHeading: { type: 'boolean', default: false },
            showSubstanceRequirementStatus: { type: 'boolean', default: true },
            requireCompleteInformation: { type: 'boolean', default: true },
            simpleOverview: {
                type: 'object',
                additionalProperties: false,
                default: {
                    requirementDisplay: 'expanded',
                },
                properties: {
                    requirementDisplay: {
                        type: 'string',
                        enum: ['expanded', 'collapsible'],
                        default: 'expanded',
                    },
                },
            },
            substanceComponent: {
                type: 'string',
                enum: SUBSTANCE_COMPONENTS,
                default: 'SubstanceV4',
            },
        },
    },
    settingsUi: {
        showSummary: { control: 'switch' },
        enableScipNumber: { control: 'switch' },
        scipNumberRequired: { control: 'switch' },
        hideCandidateListCategoriesWhenScipProvided: { control: 'switch' },
        showRequirementsHeading: { control: 'switch' },
        showSubstanceRequirementStatus: { control: 'switch' },
        requireCompleteInformation: { control: 'switch' },
        substanceComponent: {
            control: 'select',
            optionsSource: {
                type: 'static',
                values: SUBSTANCE_COMPONENTS,
            },
        },
    },
})

export { complianceInformationV2Descriptor }
export default complianceInformationV2Descriptor
